import script from "./PaymentStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatus.vue?vue&type=style&index=0&id=4789e97b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4789e97b"]])

export default __exports__